import { BaseService } from "./BaseService";

export const ConfiguracaoService = {
    async show() {
        try {
            return await BaseService.fetchResponseFromAPIGet(`configuracoes/tabelas-base`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de configurações:', error);
            return false;
        }
    }, 
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost(`configuracoes/tabelas-base`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de configurações:', error);
            return false;
        }
    }, 
}